import create, { State } from 'zustand'
import { BASE_URL } from '../constants'
import { post } from '../service/API'
import { AgeGroupEnum, AssignmentFilterEnum, ProjectWithSites, Site } from '../Types'
import { FutureVisitType } from '../pages/stats/visits/FutureVisits'

export type DateRange = {
  rawMomentRangeVal: [moment.Moment, moment.Moment]
  /** UTC start of day */
  startDatetime: number
  /** UTC end of day */
  endDatetime: number
}

export interface DataStoreType extends State {
  selectedSubject: any

  statsExtraProjects?: ProjectWithSites[]
  setStatsExtraProjects: (projects?: ProjectWithSites[]) => void

  statsSelectedDateRange?: DateRange
  setStatsSelectedDateRange: (newRange?: DateRange) => void

  /** customId */
  statsSelectedSites?: string[]

  statsSelectedCountry: 'all' | 'sanos' | string
  setStatsSelectedCountry: (val: string) => void

  hasUnappliedFilters: boolean

  setHasUnappliedFilters: (val: boolean) => void
  /** customId */
  setStatsSelectedSites: (val?: string[], isUserTouched?: boolean) => void
  setSelectedSubject: (subject: any) => void

  /** We dont want sites to be affected by suspense. */
  sites: Site[]
  setSites: (val: Site[]) => void

  /** saved in store to avoid refetch each time filters is updated */
  futureVisits: FutureVisitType[] | undefined

  setFutureVisits: (val: FutureVisitType[] | undefined) => void

  statsIncludeDbResponders: boolean
  setStatsIncludeDbResponders: (val: boolean) => void

  statsForecastExcludeStates?: string[]
  setStatsForecastExcludeStates: (val?: string[]) => void

  statsAges?: AgeGroupEnum[]
  setStatsAges: (val?: AgeGroupEnum[]) => void

  statsAssignment: AssignmentFilterEnum
  setStatsAssignment: (val: AssignmentFilterEnum) => void
}

export const dataStore = create<DataStoreType>((set: any, get: any) => {
  return {
    selectedSubject: null,
    statsSelectedDateRange: undefined,
    statsSelectedSites: undefined,
    statsIncludeDbResponders: true,
    statsExtraProjects: undefined,
    hasUnappliedFilters: false,
    sites: [],
    futureVisits: undefined,
    statsSelectedCountry: 'all',
    statsForecastExcludeStates: undefined,
    statsAges: undefined,
    statsAssignment: AssignmentFilterEnum.All,

    setStatsAges: (val?: AgeGroupEnum[]) => {
      set({ statsAges: val, hasUnappliedFilters: true })
    },

    setStatsAssignment: (val: AssignmentFilterEnum) => {
      set({ statsAssignment: val, hasUnappliedFilters: true })
    },

    setStatsForecastExcludeStates: (val?: string[]) => {
      set({ statsForecastExcludeStates: val, hasUnappliedFilters: true })
    },

    setStatsExtraProjects: (val?: ProjectWithSites[]) => {
      set({ statsExtraProjects: val, hasUnappliedFilters: true })
    },
    setStatsSelectedCountry(val: string) {
      set({ statsSelectedCountry: val, hasUnappliedFilters: true })
    },
    setStatsIncludeDbResponders: (val: boolean) => {
      // assignment only applies to db-responders, so reset it when they are excluded.
      set({
        statsIncludeDbResponders: val,
        statsAssignment: val ? get().statsAssignment : AssignmentFilterEnum.All,
        hasUnappliedFilters: true,
      })
    },
    setFutureVisits: (val: FutureVisitType[] | undefined) => {
      set({ futureVisits: val })
    },
    setSites: (val: Site[]) => {
      // note "..." for new array.
      set({ sites: [...val] })
    },
    setStatsSelectedDateRange: (newRange?: DateRange) => {
      set({ statsSelectedDateRange: newRange, hasUnappliedFilters: true })
    },

    setHasUnappliedFilters: (val: boolean) => {
      set({ hasUnappliedFilters: val })
    },

    setStatsSelectedSites: (sites?: string[], isUserTouched = false) => {
      console.log('setStatsSelectedSites:', sites)
      if (isUserTouched) {
        set({ statsSelectedSites: sites, hasUnappliedFilters: true })
      } else {
        set({ statsSelectedSites: sites })
      }
    },

    setSelectedSubject: (subject) => {
      set({ selectedSubject: subject })
    },

    loadEvaluationForm: (studyId, forms) => {
      const p = BASE_URL + '/api/evaluationForm'
      post(p, { studyId: studyId, forms: forms })
        .then((result) => {
          console.log('result = ', result)
        })
        .catch((error) => {
          console.log('error = ', error)
        })
    },
  }
})
